/**
 * How What's new lays out its counts: the fewer there are, the more room each
 * gets, so the card is never a line or two over empty space.
 *
 * - 1 count: one large tile.
 * - 2: two large tiles side by side.
 * - 3: three medium tiles in a row.
 * - 4: a 2×2 grid of medium tiles.
 * - 5–6: a three-column grid of compact tiles, counts only.
 *
 * Up to four, each tile lists the newest items behind its count — as many as
 * fit the height the tile is left with (after "For you", when it is shown),
 * like the Brief's suggestions.
 */

export type TileSize = "sm" | "md" | "lg";

export interface TileLayout {
  /** Columns from the `sm` breakpoint up; one column below it. */
  columns: 1 | 2 | 3;
  size: TileSize;
  /** Whether tiles list items (as many as fit) under their counts. */
  showExamples: boolean;
}

export function tileLayout(count: number): TileLayout {
  if (count <= 1) return { columns: 1, size: "lg", showExamples: true };
  if (count === 2) return { columns: 2, size: "lg", showExamples: true };
  if (count === 3) return { columns: 3, size: "md", showExamples: true };
  if (count === 4) return { columns: 2, size: "md", showExamples: true };
  return { columns: 3, size: "sm", showExamples: false };
}
